<script>
// import appConfig from '@src/app.config'

export default {
  page: {
    title: 'Dashboard',
    // meta: [{ name: 'description', content: appConfig.description }],
  },
  data() {
    return {
      heading: 'Welcome to Planted Private Beta',
      checkboxes: {
        selected: ['first'],
        options: [
          { text: 'Check this custom checkbox', value: 'first' },
          { text: 'Or toggle this other custom checkbox', value: 'second' },
          { text: 'This one is Disabled', value: 'third', disabled: true },
          { text: 'This is the 4th checkbox', value: { fourth: 4 } },
        ],
      },
      radios: {
        selected: 'first',
        options: [
          { text: 'Toggle this custom radio', value: 'first' },
          { text: 'Or toggle this other custom radio', value: 'second' },
          { text: 'This one is Disabled', value: 'third', disabled: true },
          { text: 'This is the 4th radio', value: { fourth: 4 } },
        ],
      },
    }
  },
  mounted: function() {
    if (location.host === 'app.planted.network') {
      this.heading = 'Welcome to Planted Network'
    } else if (location.host === 'generation.planted.network') {
      this.heading = 'Welcome to Generation Schools'
    } else if (location.host === 'app.plantedchurch.net') {
      this.heading = 'Welcome to Planted Church'
    }
  },
}
</script>

<template>
  <b-card :title="heading" sub-title="">
    <!-- <p>This is some test content</p>
    <p class="card-text">
      asdasdasdas
    </p>
    <b-form-group label="Checkbox demo:">
      <b-form-checkbox-group
        v-model="checkboxes.selected"
        :options="checkboxes.options"
        stacked
        name="checkbox-demo"
      />
    </b-form-group>
    <b-form-group label="Radios demo:">
      <b-form-radio-group
        v-model="radios.selected"
        :options="radios.options"
        stacked
        name="radio-demo"
      />
    </b-form-group> -->
  </b-card>
</template>
